import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/OrdersGuests/Get`, payload),
    OrderTracking: (payload) => Repository.post(`/api/OrdersGuests/OrderTracking`, payload),
    GetHistory: (payload) => Repository.post(`/api/OrdersGuests/GetHistory`, payload),
    GetSummary: (payload) => Repository.post(`/api/OrdersGuests/GetSummary`, payload),
    GetDetail: (payload) => Repository.post(`/api/OrdersGuests/GetDetail`, payload),
    Add: (payload) => Repository.post(`/api/OrdersGuests/Add`, payload),
    OrderTracking: (payload) => Repository.post(`/api/OrdersGuests/OrderTracking`, payload),
}
